import { httpInterceptor } from '../http-interceptor';

export class InspectionResults {
  static ENDPOINTS = {
    GET_ALL: 'Mobile/getPartsForInspectionResults',
    CREATE: 'qualityapproval/createqualityapproval',
    APPROVE_REJECT: 'InspectionPlan/requeststatusChange',
    PARTS: 'mobile/parts',
    DELETE: 'shipment/delete',
    GET_BY_ID: 'InspectionPlan/getinspectionresultbypartid',
    EXTEND: 'qualityapproval/extendqualityapproval',
  };

  static async getAllInspectionResults(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL, data);
  }
  static async approveRejectInspectionResults(data) {
    return httpInterceptor.post(this.ENDPOINTS.APPROVE_REJECT, data);
  }

  static async getInspectionResultsById(id, pageNumber = 1, pageSize = 10) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

  static async createInspectionResults(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }
  static async getParts() {
    return httpInterceptor.get(`${this.ENDPOINTS.PARTS}`);
  }
  static async extendInspectionResults(data) {
    return httpInterceptor.post(this.ENDPOINTS.EXTEND, data);
  }
}
